(() => {
  'use strict';

  const FREE_SHIPPING_THRESHOLD = 5900;
  const VITALSOP_PRODUCT_ID = 9781012365634;
  const OFFER_VARIANTS = new Set(['55979769037122', '55980623397186', '55980623429954']);
  const GIFT_VARIANTS = {
    countertop: 54953957130562,
    tray: 55972557553986,
    pouch: 55972557521218
  };
  const GIFT_CART_VARIANTS = new Set(Object.values(GIFT_VARIANTS).map(String));
  const MANAGED_CART_VARIANTS = new Set([
    ...OFFER_VARIANTS,
    ...Object.values(GIFT_VARIANTS).map(String)
  ]);
  let clearMutationTimer;
  let enhanceFrame;
  let bundleSubmitting = false;

  function markCartMutating() {
    clearTimeout(clearMutationTimer);
    document.documentElement.classList.add('vitalsop-cart-mutating');
  }

  function clearCartMutatingSoon() {
    if (bundleSubmitting) return;
    clearTimeout(clearMutationTimer);
    clearMutationTimer = setTimeout(() => {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        enhanceCart();
        document.documentElement.classList.remove('vitalsop-cart-mutating');
      }));
    }, 80);
  }

  function isCartMutationUrl(value) {
    const url = typeof value === 'string' ? value : (value && value.url) || '';
    return /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/i.test(url);
  }

  const nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (...args) {
      if (!isCartMutationUrl(args[0])) return nativeFetch.apply(this, args);
      markCartMutating();
      return nativeFetch.apply(this, args).finally(clearCartMutatingSoon);
    };
  }

  const nativeXhrOpen = XMLHttpRequest.prototype.open;
  const nativeXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__vitalsopCartMutation = isCartMutationUrl(url);
    return nativeXhrOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__vitalsopCartMutation) {
      markCartMutating();
      this.addEventListener('loadend', clearCartMutatingSoon, { once: true });
    }
    return nativeXhrSend.apply(this, args);
  };

  function selectedManagedOffer() {
    const radio = document.querySelector('.offer-card__radio-input:checked');
    if (!radio || !OFFER_VARIANTS.has(String(radio.dataset.variantId))) return null;
    if (radio.dataset.onetime !== 'true' && !radio.dataset.planId) return null;
    return radio;
  }

  function giftItemsForOffer(radio) {
    if (radio.dataset.onetime === 'true') return [];
    const giftFor = radio.dataset.supplyDays === '90' ? '90-day subscription' : '30-day subscription';
    const ids = radio.dataset.supplyDays === '90'
      ? [GIFT_VARIANTS.tray, GIFT_VARIANTS.pouch, GIFT_VARIANTS.countertop]
      : [GIFT_VARIANTS.countertop];
    return ids.map(id => ({
      id,
      quantity: 1,
      properties: { _vitalsop_welcome_gift_for: giftFor }
    }));
  }

  async function fetchCartJson(url, options) {
    const response = await window.fetch(url, options);
    if (!response.ok) {
      const detail = await response.text().catch(() => '');
      throw new Error(`Cart request failed (${response.status}) ${detail}`.trim());
    }
    return response.json();
  }

  async function replaceOfferBundle(radio, button) {
    if (bundleSubmitting) return;
    bundleSubmitting = true;
    markCartMutating();
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      const ocuCart = currentCart();
      const current = Array.isArray(ocuCart?.items)
        ? ocuCart
        : await fetchCartJson('/cart.js', { headers: { Accept: 'application/json' } });
      const updates = {};
      (current.items || []).forEach(item => {
        if (MANAGED_CART_VARIANTS.has(String(item.variant_id))) updates[item.key] = 0;
      });
      if (Object.keys(updates).length) {
        await fetchCartJson('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

      const parentItem = {
        id: Number(radio.dataset.variantId),
        quantity: 1
      };
      if (radio.dataset.planId) parentItem.selling_plan = Number(radio.dataset.planId);
      const items = [parentItem, ...giftItemsForOffer(radio)];

      await fetchCartJson('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });

      const ocu = window.Zipify?.Cart?.instance;
      let cart = null;
      try {
        if (ocu?.updateCart) {
          await Promise.resolve(ocu.updateCart());
          cart = currentCart();
        }
        if (!cart?.items) {
          cart = await fetchCartJson('/cart.js', { headers: { Accept: 'application/json' } });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        if (ocu?.openCart) ocu.openCart();
        else if (ocu?.openUpdatedCart) ocu.openUpdatedCart();
      } catch (refreshError) {
        console.warn('[VitalSop bundle] Bundle added, but the cart drawer refresh failed', refreshError);
      }
    } catch (error) {
      console.error('[VitalSop bundle] Unable to add offer bundle', error);
      window.alert('We could not add your VitalSop bundle. Please try again.');
    } finally {
      bundleSubmitting = false;
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      clearCartMutatingSoon();
    }
  }

  function interceptManagedAdd(event, button, form) {
    const radio = selectedManagedOffer();
    if (!radio) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    replaceOfferBundle(radio, button || form?.querySelector('[type="submit"]'));
    return true;
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('.product-form__submit, [name="add"], #sticky-atc-btn');
    if (!button) return;
    const form = button.closest('form') || document.querySelector('form[action*="/cart/add"]');
    interceptManagedAdd(event, button, form);
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    interceptManagedAdd(event, form.querySelector('[type="submit"]'), form);
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-form__submit, [name="add"], #sticky-atc-btn')) {
      markCartMutating();
      clearTimeout(clearMutationTimer);
      clearMutationTimer = setTimeout(clearCartMutatingSoon, 4000);
    }
  }, true);

  function currentCart() {
    return window.Zipify?.Cart?.instance?.cart || window.Zipify?.Cart?.cart || null;
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currentCart()?.currency || 'USD'
    }).format(cents / 100);
  }

  function bottleCount(item) {
    const source = `${item.variant_title || ''} ${item.title || ''}`;
    const match = source.match(/(\d+)\s*bottle/i);
    return match ? Number(match[1]) : Math.max(1, Number(item.quantity) || 1);
  }

  function cadenceText(item) {
    const count = bottleCount(item);
    const bottleWord = count === 1 ? 'bottle' : 'bottles';
    const plan = item.selling_plan_allocation?.selling_plan?.name || '';
    const days = plan.match(/(\d+)\s*day/i);
    if (days) return `${count} ${bottleWord} every ${days[1]} days`;
    if (plan) return `${count} ${bottleWord} ${plan.toLowerCase()}`;
    return `${count} ${bottleWord} once`;
  }

  function updateCadence(cart) {
    const rows = [...document.querySelectorAll('.ocu-cart-line-item-wrapper')];
    rows.forEach((row, index) => {
      const item = cart.items?.[index];
      if (!item || Number(item.product_id) !== VITALSOP_PRODUCT_ID) return;
      const variant = row.querySelector('.ocu-cart-line-item-product-variant');
      if (variant) variant.textContent = cadenceText(item);
    });
  }

  function updateShipping(cart) {
    const banner = document.querySelector('.ocu-cart-banner');
    const message = banner?.querySelector('.ocu-cart-banner--message-text');
    if (!banner || !message) return;

    const subtotal = Number(cart.total_price ?? cart.items_subtotal_price ?? 0);
    const subscriptionQualifies = Boolean(
      cart.items?.some(item => item.selling_plan_allocation)
    );
    const remaining = subscriptionQualifies
      ? 0
      : Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
    const progress = subscriptionQualifies
      ? 100
      : Math.min(100, Math.max(0, subtotal / FREE_SHIPPING_THRESHOLD * 100));
    const text = remaining > 0
      ? `You're ${money(remaining)} away from FREE SHIPPING`
      : '🎉 Congrats! You’ve unlocked FREE SHIPPING!';

    if (message.textContent !== text) message.textContent = text;
    let bar = banner.querySelector('.vitalsop-shipping-progress');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'vitalsop-shipping-progress';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span></span>';
      banner.appendChild(bar);
    }
    const fill = bar.firstElementChild;
    const width = `${progress.toFixed(2)}%`;
    if (fill.style.width !== width) fill.style.width = width;
  }

  function updateGiftPresentation(cart) {
    const rows = [...document.querySelectorAll('.ocu-cart-line-item-wrapper')];
    rows.forEach((row) => {
      const variantId = String(row.dataset.key || '').split(':')[0];
      let properties = {};
      try {
        properties = JSON.parse(row.dataset.properties || '{}');
      } catch (_) {}
      const isWelcomeGift = properties._vitalsop_welcome_gift === 'true'
        || GIFT_CART_VARIANTS.has(variantId);
      row.classList.toggle('vitalsop-ocu-hidden-gift', isWelcomeGift);
      if (isWelcomeGift) row.setAttribute('aria-hidden', 'true');
      else row.removeAttribute('aria-hidden');
    });

    const visibleQuantity = (cart.items || []).reduce((total, item) => {
      return GIFT_CART_VARIANTS.has(String(item.variant_id))
        ? total
        : total + Math.max(1, Number(item.quantity) || 1);
    }, 0);
    const visibleText = String(visibleQuantity);
    const count = document.querySelector('.ocu-cart-header--items-count span');
    if (count && count.textContent !== visibleText) count.textContent = visibleText;
    const accessibleCount = document.querySelector('[data-testid="cart-count"]');
    const accessibleText = `${visibleQuantity} ${visibleQuantity === 1 ? 'item' : 'items'}`;
    if (accessibleCount && accessibleCount.textContent !== accessibleText) {
      accessibleCount.textContent = accessibleText;
    }
  }

  function enhanceCart() {
    const cart = currentCart();
    if (!cart || !document.querySelector('.ocu-cart-container')) return;
    updateShipping(cart);
    updateCadence(cart);
    updateGiftPresentation(cart);
  }

  function scheduleEnhance() {
    cancelAnimationFrame(enhanceFrame);
    enhanceFrame = requestAnimationFrame(enhanceCart);
  }

  new MutationObserver(scheduleEnhance).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  document.addEventListener('DOMContentLoaded', scheduleEnhance);
  window.addEventListener('pageshow', scheduleEnhance);
})();
